<div>
	<div class="row"></div>
	<hl-proxy-list-item *ngFor="let holding of portfolio.children" class="row content-row-border row-margin-override padding-vertical-20" [security]="holding">
	</hl-proxy-list-item>
</div>
